import React, { useEffect } from 'react';

const AIFPage = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
    link.rel = "stylesheet";
    link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
    document.head.appendChild(link);

    return () => {
      // Optional: Clean up when component unmounts
      document.getElementById("tailwind-mutualfund")?.remove();
    };
  }, []);
  return (
    <>
      {/* <!-- Hero Section --> */}
      <section className="bg-blue-50 py-16 text-center">
        <h1 className="text-4xl font-bold text-blue-900 mb-4">Invest in AIFs (Alternative Investment Funds)</h1>
        <p className="text-lg text-gray-700 mb-6">Diversify your portfolio with high-growth opportunities in private equity, venture capital, and real assets through GPS Finvest.</p>
        <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Explore AIF Opportunities</a></div>
      </section>

      {/* <!-- What is AIF --> */}
      <section className="py-16 bg-white">
        <div className='col-md-12' style={{ display: 'flex', justifyContent: 'center' }}>
          <img src='/images/AIF.png' style={{ height: '300px' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 text-center mt-2">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What is an Alternative Investment Fund (AIF)?</h2>
          <p className="text-lg text-gray-600">AIFs are privately pooled investment funds that invest in assets beyond traditional equities and debt, such as private equity, venture capital, hedge funds, and infrastructure. They are ideal for sophisticated investors seeking diversification, higher returns, and strategic exposure.</p>
        </div>
      </section>

      {/* <!-- Why Choose GPS Finvest --> */}
      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">Why Invest in AIFs Through GPS Finvest?</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Curated_AIFs.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Curated AIFs</h3>
              <p>We shortlist only SEBI-registered high-performing AIFs.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Diverse_Strategies.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Diverse Strategies</h3>
              <p>Choose from growth equity, hedge, credit, real estate and more.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Dedicated_Advisory.jpg" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Dedicated Advisory</h3>
              <p>Access expert wealth advisors for AIF portfolio planning.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Support.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">End-to-End Support</h3>
              <p>From onboarding to compliance, we manage everything for you.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Updated How to Invest in AIFs --> */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">How to Start Your AIF Investment Journey</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">1. Book a Call</h3>
              <p>Connect with our wealth expert for a personalized AIF walkthrough.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">2. Portfolio Suitability</h3>
              <p>We assess your risk appetite and long-term goals to match ideal AIFs.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">3. Investment Structuring</h3>
              <p>Choose from growth, credit, real estate, or hybrid AIFs with custom allocations.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">4. Hassle-Free Onboarding</h3>
              <p>We handle all documentation, KYC, fund transfer, and regulatory filings end-to-end.</p>
            </div>
          </div>
          <div className="mt-8">
            {/* <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Schedule Consultation</a></div> */}
            <div ><a className="btn btn-primary" href="#"><i className="fa-solid fa-phone"></i>  Schedule Consultation</a></div>
          </div>
        </div>
      </section>

      {/* <!-- AIF Benefits --> */}
      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Benefits of AIF Investing</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Higher Returns</h3>
              <p>AIFs provide access to high-growth sectors like private equity and startups.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Strategic Diversification</h3>
              <p>Reduce dependence on traditional markets with alternative assets.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Wealth Preservation</h3>
              <p>Structured investment vehicles offering risk-managed long-term growth.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AIFPage;
